import WorkExperience from "./work-experience";

export default WorkExperience;
